// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".bundle.js?" + {"node_modules_babel-loader_lib_index_js_ruleSet_1_rules_0_use_0_lib_ga-metadata_js":"b96ea9a1364b3490278b","internal_routes_js":"649f5ca443d9f97c204e"}[chunkId] + "";
};